import {LocalPreferencesModel} from '../../../models/api/localPreferencesModel';
import {AppAction} from '../../appActions';
import {LocalPreferencesActionsEnum} from './localPreferencesActions';

export function localPreferencesReducer(
  state: LocalPreferencesModel,
  action: AppAction,
): LocalPreferencesModel {
  switch (action.type) {
    case LocalPreferencesActionsEnum.LOCAL_PREFERENCES_UPDATED:
      return action.payload;

    default:
      return state;
  }
}
